<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: 'vertical-bar-chart',
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      },
    },
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // plugins: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // },
    chartData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // const chartData = {
    //   labels: [ 'January', 'February', 'March' ],
    //   datasets: [ { data: [40, 20, 12] } ]
    // }

    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
      indexAxis: 'y',
    };

    // be careful with nested option objects, this will overwrite first level key from default if defined in props.
    const chartOptions = { ...defaultOptions, ...props.options };

    return {
      chartOptions,
    };
  },
};
</script>
